<template>
	<v-app>
		<v-main>
			<v-container class="fill-height" fluid>
				<div class="background-image"></div>
				<v-row justify="center" align="center">
					<v-col cols="12" sm="8" md="6" lg="4">
						<v-card elevation="12" class="pa-6 rounded-lg">

							<v-card-title class="text-h4 justify-center primary--text mb-6">
								密码重置
							</v-card-title>

							<v-card-text>
								<!-- 用户名 & 密码 -->
								<v-row>
									<v-col cols="12" md="12">
										<v-text-field label="用户名" v-model.trim="loginForm.loginName"
											prepend-icon="mdi-account" outlined dense
											:rules="[v => !!v || '用户名不能为空',v => v.length >= 4 || '用户名至少4个字符']"></v-text-field>
									</v-col>
								</v-row>

								<!-- 手机验证 -->
								<v-row class="mt-2">
									<v-col cols="12" sm="8">
										<v-text-field v-model.trim="loginForm.mobile" label="手机号码"
											prepend-icon="mdi-cellphone" outlined dense :rules="[
                      v => !!v || '手机号不能为空',
                      v => /^1[3-9]\d{9}$/.test(v) || '手机号格式不正确'
                    ]"></v-text-field>
									</v-col>
									<v-col cols="12" sm="4">
										<v-btn color="secondary" block @click="getCaptcha">
											获取验证码
										</v-btn>
									</v-col>
								</v-row>

								<v-row>
									<v-col cols="12" sm="12">
										<!-- 邀请码 -->
										<v-text-field label="验证码" v-model.trim="loginForm.invitationCode"
											prepend-icon="mdi-account-key" outlined dense @click:rules="[v => !!v || '验证码不能为空',
										v => v.length >= 6 || '验证码是6位']">
										</v-text-field>
									</v-col>
								</v-row>

								<v-row>
									<v-col cols="12" md="12">
										<v-text-field label="新密码" v-model.trim="loginForm.password"
											prepend-icon="mdi-lock" :type="showPassword ? 'text' : 'password'" outlined
											dense :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
											@click:append="showPassword = !showPassword" :rules="[v => !!v || '密码不能为空',
										v => v.length >= 6 || '密码至少6个字符']"></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" md="12">
										<v-text-field label="确认新密码" v-model.trim="loginForm.checkPassword"
											prepend-icon="mdi-lock" :type="showPassword ? 'text' : 'password'" outlined
											dense :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
											@click:append="showPassword = !showPassword" :rules="[v => !!v || '密码不能为空',
										v => v.length >= 6 || '密码至少6个字符']"></v-text-field>
									</v-col>
								</v-row>

								<v-alert v-if="msg" :type="msgType" dense class="mt-2">
									{{ msg }}
								</v-alert>
							</v-card-text>

							<!-- 底部链接 -->
							<v-card-actions class="justify-center grey lighten-4">
								<v-btn text small color="secondary">确定重置</v-btn>
								<v-divider vertical></v-divider>
								<v-btn text small color="secondary" to="login">登录</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
	export default {
		data() {
			return {
				loginForm: {
					loginName: '',
					mobile: '',
					captcha: '',
					password: '',
					checkPassword: ''
				},
				confirmPassword: '',
				showPassword: false,
				showConfirmPassword: false,
				msg: null,
				msgType: 'error',
				loading: false,
				sending: false,
				countdown: 0,
				isUsernameValid: false,
				isMobileValid: false,
				captchaKey: null
			};
		},
		watch: {
			'loginForm.mobile': function(newVal) {
				this.isMobileValid = /^1[3-9]\d{9}$/.test(newVal);
			}
		},
		methods: {
			async checkUsername() {
				if (this.loginForm.loginName.length < 4) {
					this.isUsernameValid = false;
					return;
				}

				// 模拟检查用户名是否存在
				try {

					const response = await this.$axios.post('/kt-supplier/resetPw', {
						user: this.loginForm
					})

					if (response.data.state == 200) {
						this.msg = "重置成功，可以用新密码登录系统";
					} else {
						this.msg = this.data.msg;
					}

				} catch (error) {
					this.msg = "用户名不存在";
					this.msgType = "error";
					this.isUsernameValid = false;
				}
			},

			async getCaptcha() {
				if (!this.isMobileValid) {
					this.msg = "请输入正确的手机号码";
					this.msgType = "error";
					return;
				}

				this.captchaKey = "kt11";
				this.sending = true;
				this.msg = null;

				try {
					// 模拟发送验证码的API调用
					const response = await this.$axios.post('/kt-supplier/getCaptcha', {
						tel: this.loginForm.mobile,
						captchaKey: this.captchaKey
					})

					if (response.data.state == 200) {
						this.msg = "验证码已发送到你手机";
					} else {
						this.msg = this.data.msg;
					}

					// 开始倒计时
					this.countdown = 60;

					const timer = setInterval(() => {
						this.countdown--;
						if (this.countdown <= 0) {
							clearInterval(timer);
						}
					}, 1000);

				} catch (error) {
					this.msg = "验证码发送失败，请稍后重试";
					this.msgType = "error";
				} finally {
					this.sending = false;
				}
			},

			async resetPassword() {
				// 表单验证
				if (!this.loginForm.loginName) {
					this.msg = "请输入用户名";
					this.msgType = "error";
					return;
				}

				if (!this.isMobileValid) {
					this.msg = "请输入正确的手机号码";
					this.msgType = "error";
					return;
				}

				if (!this.loginForm.captcha || !/^\d{6}$/.test(this.loginForm.captcha)) {
					this.msg = "请输入正确的6位验证码";
					this.msgType = "error";
					return;
				}

				if (!this.loginForm.password || this.loginForm.password.length < 6) {
					this.msg = "密码至少需要6个字符";
					this.msgType = "error";
					return;
				}

				if (this.loginForm.password !== this.confirmPassword) {
					this.msg = "两次输入的密码不一致";
					this.msgType = "error";
					return;
				}

				this.loading = true;
				this.msg = null;

				try {
					// 模拟API调用
					await new Promise(resolve => setTimeout(resolve, 2000));

					// 模拟成功响应
					this.msg = "密码重置成功，请使用新密码登录";
					this.msgType = "success";

					// 清空表单
					this.loginForm.captcha = '';
					this.loginForm.password = '';
					this.confirmPassword = '';

					// 3秒后跳转到登录页
					setTimeout(() => {
						this.goToLogin();
					}, 3000);
				} catch (error) {
					this.msg = "密码重置失败，请检查验证码是否正确";
					this.msgType = "error";
				} finally {
					this.loading = false;
				}
			},

			goToLogin() {
				alert("这里会跳转到登录页面");
				// 实际应用中应该是: this.$router.push('/login');
			}
		}
	};
</script>

<style>
	.background-image {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: left;
		pointer-events: none;
		background-image: url(./../assets/seagull-bg.png);
		background-color: #00599b;
		opacity: 0.6
	}
</style>